const product = require('./product');
const { replaceTextWithValues } = require('../utils/text-replace');

let lmnEndpoint = null;
let mu2Endpoint = null;

// Muse dirty products are split up by locale, e.g. KOY has 4 locales (en, es,
// it, nl) so it has four products (kingdom-of-you-en, ...).
const mu2ProductsPerLocale = [
  'KOY',
  'MGT',
  'TBT',
];

const isMu2PerLocale = sku => mu2ProductsPerLocale.includes(sku);
const isChameleon = sku => (sku === product.skus.LMN);
const isMu2 = sku => !(isChameleon(sku));

const createProductCode = (sku, locale) => {
  switch (true) {
    case isMu2PerLocale(sku):
      return `${product.museEndpoints[sku]}-${locale}`;
    default:
      return product.museEndpoints[sku];
  }
};

const createMuseBaseUrl = (productKey, locale) => {
  const productCode = createProductCode(productKey, locale);
  return mu2Endpoint.replace('{sku}', productCode);
};

const setMU2Endpoint = value => {
  mu2Endpoint = value;
  return module.exports;
};

const setLMNEndpoint = value => {
  lmnEndpoint = value;
  return module.exports;
};

const getPreviewBaseUrl = (sku, locale) => {
  switch (sku) {
    case product.skus.LMN:
      return lmnEndpoint;
    default:
      const productKey = product.findKeyBy.sku(sku);
      return createMuseBaseUrl(productKey, locale);
  }
};

const buildPreviewUrl = (sku, params) => {
  // According to @robertwatts there will never be an english locale that isn't "en"
  const locale = params.locale && params.locale.startsWith('en') ? 'en' : params.locale;
  const url = getPreviewBaseUrl(sku, locale);

  return url;
};

/**
 * buildMusePreviewUrl - Similar to buildPreviewUrl and getPreviewBaseUrl however we no longer need to
 * validate the sku from the config object.
 *
 * @param id muse id from Prismic
 * @param params user customisations
 * @returns {string}
 */
const buildMusePreviewUrl = (id, params) => {
  // According to @robertwatts there will never be an english locale that isn't "en"
  const locale = params.locale && params.locale.startsWith('en') ? 'en' : params.locale;

  // handles skus that look like "[PRODUCT_ID]-%{locale}"
  const museId = replaceTextWithValues(id, { locale });
  return mu2Endpoint.replace('{sku}', museId);
};

module.exports = {
  isMu2,
  isChameleon,
  setLMNEndpoint,
  setMU2Endpoint,
  getPreviewBaseUrl,
  buildPreviewUrl,
  buildMusePreviewUrl,
};
